import React from 'react';

const Interviews = () => {
    return (
        <div>
            Interviews
            
        </div>
    );
};

export default Interviews;